
import { Component, OnInit }  from '@angular/core';
import { Store } from "@ngrx/store";
import { AppState } from "../../../reducers";
import { MessageActions } from "../../../actions";
import { Tabs, Tab, LeoBox, EventBasicDataForm, SeatsForm, Alert, Spinner, Modal, Files, YoutubeVideosComponent } from '../../../ui-helper';
import { Router } from '@angular/router';
import { TicketQuotaCollection } from '../ticket-quota-collection/ticket-quota-collection.component'
import { EventApi, HttpClient, PriceApi, MerchantApi }   from "../../../services/webservice";
import { Event, FileMediaData, YoutubeVideo, Category, EventCategory } from "../../../models";
import { LoaderService, LoadProcess } from "../../../services"
import { CategoriesComponent } from "../categories/categories.component";
import { EventStatusComponent } from "../event-status/event-status.component"
import { Location } from '@angular/common';
import { Observable, Subscription } from 'rxjs'

@Component({
	selector: 'event',
	templateUrl: "./event-form.html",
	styles: [require("./event-form.scss")]
})
export class EventFormComponent implements OnInit {
	private spinnerCallback = () => { };
	private static showDeleteSuccess = false;
	private static errors: any = {};
	private static preserveStateForNextCreation = false;

	private loadedEventSubscription: Subscription;
	private eventCategorySubscription: Subscription;

	public showSpinner = false;
	public showDelete = false;
	public loadedEvent: Event;
	public distributionChannels$: Observable<string[]>
	public eventCategories$: Observable<EventCategory[]>
	public eventCategory: EventCategory

	constructor(
		private router: Router,
		private store: Store<AppState>,
		private messageActions: MessageActions,
		private eventApi: EventApi,
		private priceApi: PriceApi,
		private loaderService: LoaderService,
		private location: Location,
		private merchantApi: MerchantApi) {
		if (!EventFormComponent.preserveStateForNextCreation) {
			this.resetError();
		} else {
			EventFormComponent.preserveStateForNextCreation = false;
		}
	}

	get class() {
		return EventFormComponent;
	}
	public setImagesAndSave(images: FileMediaData[]) {
		this.loadedEvent.images = images;
		this.saveEvent({ event: this.loadedEvent, eventCategory: this.eventCategory });
	}
	public getImages(): FileMediaData[] {
		if (this.loadedEvent) {
			return this.loadedEvent.images
		} else {
			return []
		}
	}

	public getMiscMediaData() {
		if (this.loadedEvent) {
			return this.loadedEvent.miscFiles
		} else {
			return []
		}
	}

	public setMiscMediaDataAndSave(miscFiles: FileMediaData[]) {
		this.loadedEvent.miscFiles = miscFiles;
		this.saveEvent({ event: this.loadedEvent, eventCategory: this.eventCategory });
	}

	ngOnInit() {
		this.loadedEventSubscription = this.store.select("eventServerState", "event", "currentEvent")
			.subscribe(event => this.loadedEvent = event)

		this.eventCategorySubscription = this.store.select("eventServerState", "eventCategories", "currentEventCategory")
			.subscribe(eventCategory => this.eventCategory = eventCategory)

		this.eventCategories$ = this.store.select("eventServerState", "eventCategories", "eventCategories")
		this.distributionChannels$ = this.merchantApi.getDistributionChannels()
	}

	ngOnDestroy() {
		this.loadedEventSubscription.unsubscribe()
		this.eventCategorySubscription.unsubscribe()
	}

	saveEvent(formData: {event: Event, eventCategory: EventCategory}) {
		if (formData.event._links) {
			this.updateEvent(formData.event, formData.eventCategory);
		} else {
			this.createEvent(formData.event, formData.eventCategory);
		}
	}

	videosChanged(videos: YoutubeVideo[]) {
		this.loadedEvent.youTubeVideos = videos
		this.saveEvent({ event: this.loadedEvent, eventCategory: this.eventCategory })
	}

	public deleteYes() {
		this.showDelete = false;
		this.showSpinner = true;
		this.eventApi.deleteEvent(this.loadedEvent.storageId).subscribe(
			data => {
				EventFormComponent.preserveStateForNextCreation = true;
				this.loadedEvent = null
				this.spinnerCallback = () => {
					this.router.navigate(["/events/new"])
					this.store.dispatch(this.messageActions.displayMessage("Ihre Veranstaltung wurde erfolgreich gelöscht!", "success"))
				};
				this.showSpinner = false
			},
			error => {
				this.handleError(error)
				this.showSpinner = false
			});
	}

	public deleteNo() {
		this.showDelete = false;
	}

	private resetError() {
		EventFormComponent.errors = {};
	}

	private updateEvent(event: Event, eventCategory: EventCategory) {
		this.showSpinner = true
		this.resetError();

		this.eventApi.patchEvent(this.loadedEvent.storageId.toString(), event).subscribe(
			data => {
				this.loadedEvent = data
				this.eventApi.setReferences(data._links.eventCategory.href, [eventCategory._links.self.href]).subscribe(
					response => {
						this.showSpinner = false
						this.store.dispatch(this.messageActions.displayMessage("Ihre Veranstaltung wurde erfolgreich gespeichert!", "success"))
					},
					error => {
						this.showSpinner = false
						this.handleError(error)
					})
			},
			error => {
				this.showSpinner = false
				this.handleError(error)
			}
		)
	}

	private createEvent(event: Event, eventCategory: EventCategory) {
		this.showSpinner = true
		this.resetError();
		this.eventApi.createEvent(event).subscribe(
			data => {
				EventFormComponent.preserveStateForNextCreation = true;
				this.loadedEvent = data
				this.eventApi.setReferences(data._links.eventCategory.href, [eventCategory._links.self.href]).subscribe(
					response => {
						this.showSpinner = false
						this.router.navigate(["/events", this.loadedEvent.storageId]);
						this.store.dispatch(this.messageActions.displayMessage("Ihre Veranstaltung wurde erfolgreich gespeichert!", "success"))
					},
					error => {
						this.showSpinner = false
						this.handleError(error)
					})
			},
			error => {
				this.showSpinner = false
				this.handleError(error)
			}
		);
	}

	private handleError(error: any) {
		if (!error.messageDe) {
			error.messageDe = "Es ist ein unerwarteter Fehler aufgetreten."
		}
		this.store.dispatch(this.messageActions.displayMessage(error.messageDe, "error"));

		EventFormComponent.errors = error;
	}

	private updateEventResultSet(event: Event) {
		this.loadedEvent = event
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-form/event-form.component.ts